import { render, staticRenderFns } from "./training_course.vue?vue&type=template&id=17dcf7d7&scoped=true&"
import script from "./training_course.vue?vue&type=script&lang=js&"
export * from "./training_course.vue?vue&type=script&lang=js&"
import style0 from "./training_course.vue?vue&type=style&index=0&id=17dcf7d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dcf7d7",
  null
  
)

export default component.exports